/**
 * parse a data array and return a copy with date objects
 * uses Object.assign to make a shallow copy (because apollo-client deep-freezes results)
 * @param  {Array}  dataArray     chart data array with { d, v } objects
 * @param  {String} [dateKey='d'] use a key other than `d` for the date
 * @return {Array}                copy of the array with parsed dates
 */
export default (dataArray, dateKey = 'd') => dataArray.map((e) => {
    const date = new Date(e[dateKey]);
    const newObj = Object.assign({}, e);
    newObj[dateKey] = date;
    return newObj;
});



// WEBPACK FOOTER //
// ./src/functions/parseDates.js